import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popup } from 'semantic-ui-react';

import { Info } from 'common/images/FaIcons';
import colors from 'common/styles/colors';

// Icon-only tooltip replacing a paragraph of helper text. Semantic's Popup is
// kept for portalling; `&&&` outranks the `.ui.popup` defaults. Exported so
// other triggers (a disabled button's reason) show the same tooltip.
export const StyledPopup = styled(Popup)`
  &&& {
    background: ${colors.white};
    border: 1px solid ${colors.borderGray};
    border-radius: 6px;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.12);
    padding: 12px 14px;
    max-width: 300px;
    font-family: 'Petasense Open Sans';
    font-size: 12px;
    font-weight: 300;
    line-height: 1.6;
    color: ${colors.greyXXD};

    &:before {
      background: ${colors.white};
      box-shadow: -1px -1px 0 0 ${colors.borderGray};
    }
  }
`;

const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  padding: 0;
  margin-left: 6px;
  line-height: 1;
  color: ${colors.darkGray};
  cursor: pointer;

  &:hover {
    color: ${colors.green};
  }

  &:focus-visible {
    outline: 2px solid ${colors.green};
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

const InfoTooltip = ({ content, position, size, label, className }) => (
  <StyledPopup
    className={className}
    trigger={(
      <TriggerButton type="button" aria-label={label}>
        <Info size={size} />
      </TriggerButton>
    )}
    content={content}
    position={position}
    on={['hover', 'focus']}
  />
);

InfoTooltip.propTypes = {
  content: PropTypes.node.isRequired,
  position: PropTypes.string,
  size: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string
};

InfoTooltip.defaultProps = {
  position: 'bottom left',
  // FontAwesome only accepts its own size tokens; a number yields fa-14, which
  // has no rule, so the icon silently falls back and dev logs a prop warning.
  size: 'sm',
  className: undefined
};

export default InfoTooltip;
